export default __webpack_public_path__ + "static/media/AICounsellingBanner.fbe1ba4c8af78ed9317c8f9b08624a13.webp";